module.exports = __webpack_public_path__ + "img/reco4.b68b324f.jpg";